// orderSlice.js
import { apiSlice } from "./apiSlice";
import {
  CREATE_ORDER_URL,
  GET_CUSTOMER_ORDERS_URL,
  GET_ORDER_DETAILS_URL,
} from "../constants";

export const orderSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (data) => ({
        url: CREATE_ORDER_URL,
        method: "POST",
        body: data,
      }),
    }),
    getCustomerOrders: builder.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: GET_CUSTOMER_ORDERS_URL,
        params: { page, limit },
      }),
    }),
    getOrderDetails: builder.query({
      query: (orderId) => `${GET_ORDER_DETAILS_URL}/${orderId}`,
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useGetCustomerOrdersQuery,
  useGetOrderDetailsQuery,
} = orderSlice;
